import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import CreateProgramRedeem from "./createprogramRedeem.component";

class ProgramRedeem extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
  }

  state = {
    name: "",
    sortBy: "points",
    limit: 10,
    totalResults: 0,
    page: 1,
    redemption: [],
    search: "",
    create: 0,
    resp: null,
  };

  componentDidMount() {
    this.fetchRedemption();
  }

  fetchRedemption = async () => {
    try {
      const token = localStorage.getItem("token");

      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);

      const pathSegments = window.location.pathname.split("/");
      let compid = pathSegments[pathSegments.length - 2];

      let url = "";

      if (this.state.search !== "") {
        url =
          "program/child/redeem-product?name=" +
          this.state.search +
          "&sortBy=" +
          this.state.sortBy +
          "&limit=" +
          this.state.limit +
          "&page=" +
          this.state.page;
      } else {
        url =
          "program/child/redeem-product?sortBy=" +
          this.state.sortBy +
          "&limit=" +
          this.state.limit +
          "&page=" +
          this.state.page;
      }

      const resp = await axios.get(Constants.api + url, {
        headers: {
          Authorization: `Bearer ${token}`,
          company: compid,
          program: programid,
          appVersion: Constants.av,
          platform: Constants.pt,
        },
      });

      if (resp.status === 201 && resp.data.result !== "error") {
        this.setState({
          redemption: resp.data.output.results,
          totalResults: resp.data.output.totalResults || resp.data.output.count || 0,
        });
      } else if (resp.status === 403) {
        localStorage.clear();
        window.location.href = "/";
      }
    } catch (err) {
      console.error(err);
    }
  };

  searchHandleChange = (event) => {
    this.setState(
      {
        search: event.target.value,
        page: 1,
      },
      () => this.fetchRedemption()
    );
  };

  handlePageChange = (pageNumber) => {
    this.setState(
      {
        page: pageNumber,
      },
      () => this.fetchRedemption()
    );
  };

  handleLimitChange = (event) => {
    this.setState(
      {
        limit: event.target.value,
        page: 1,
      },
      () => this.fetchRedemption()
    );
  };

  handleViewMode = (data) => {
    this.setState({ create: data });
    this.fetchRedemption();
  };

  editItem = (id) => {
    try {
      const token = localStorage.getItem("token");

      axios
        .get(Constants.api + "program/child/redeem-product/" + id, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("language"),
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            this.setState({
              create: 1,
              resp: resp,
            });
          }
        });
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const redemptionRender = this.state.redemption.map((item) => {
      return (
        <tr key={item.id}>
          <td>{item.product?.name}</td>

          <td>{item.points}</td>

          <td>{item.active ? "Active" : "Deactive"}</td>

          <td>
            {moment(item.createDateTime).format("DD MMM YYYY")}
          </td>

          <td>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => this.editItem(item.id)}
            >
              <i className="material-icons text-lg">edit</i> Edit
            </button>
          </td>
        </tr>
      );
    });

    return (
      <>
        {this.state.create === 0 ? (
          <>
            <main>
              <div className="container-fluid py-4">
                <div className="card">

                  <div className="card-header pb-0">
                    <div className="d-lg-flex">

                      <div>
                        <h5 className="mb-0">Program Redemption</h5>
                      </div>

                      <div className="ms-auto">

                        <button
                          className="btn bg-gradient-primary mb-2"
                          onClick={() => this.setState({ create: 1 })}
                        >
                          <i className="material-icons text-white pe-2">
                            add
                          </i>
                          Add New
                        </button>

                      </div>
                    </div>
                  </div>

                  <div className="card-body">

                    <div className="row mb-3">

                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          onChange={this.searchHandleChange}
                        />
                      </div>

                      <div className="col-md-2">
                        <select
                          className="form-control"
                          value={this.state.limit}
                          onChange={this.handleLimitChange}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>

                    </div>

                    <div className="table-responsive">
                      <table className="table table-flush">

                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Points</th>
                            <th>Status</th>
                            <th>Created On</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {redemptionRender}
                        </tbody>

                      </table>
                    </div>

                  </div>
                </div>
              </div>
            </main>

            <div className="pagination-container">

              <Pagination
                activePage={this.state.page}
                itemsCountPerPage={this.state.limit}
                totalItemsCount={this.state.totalResults}
                pageRangeDisplayed={5}
                onChange={this.handlePageChange}
              />

            </div>
          </>
        ) : this.state.resp ? (
          <CreateProgramRedeem
            resp={this.state.resp}
            setViewMode={this.handleViewMode}
          />
        ) : (
          <CreateProgramRedeem setViewMode={this.handleViewMode} />
        )}
      </>
    );
  }
}

export default ProgramRedeem;